<template>
  <div
    class="modal modal-contact-create fade fixed-end"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">
            {{ title }}
          </h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <!-- /.drawer-heading -->

        <div class="modal-body">
          <div class="mb-3">
            <label class="control-label">First Name</label>
            <div class="input-group">
              <input
                name="first_name"
                v-model="editContact.first_name"
                type="text"
                class="form-control"
                data-vv-validate-on="input|blur"
                data-vv-as="first name"
                v-validate="'required'"
              />
            </div>
            <!-- /.input-group -->

            <help-block field="first_name" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3">
            <label class="control-label">Surname</label>
            <div class="input-group">
              <input
                name="surname"
                v-model="editContact.surname"
                type="text"
                class="form-control"
                data-vv-validate-on="input|blur"
                data-vv-as="surname"
                v-validate="'required'"
              />
            </div>
            <!-- /.input-group -->

            <help-block field="surname" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3">
            <label class="control-label">Email</label>
            <div class="input-group">
              <input
                name="email"
                v-model="editContact.email"
                type="text"
                class="form-control"
                data-vv-validate-on="input|blur"
                v-validate="'required|email'"
              />
            </div>
            <!-- /.input-group -->

            <help-block field="email" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3">
            <label class="control-label">Phone</label>
            <div class="input-group">
              <input
                name="phone"
                v-model="editContact.phone"
                type="text"
                class="form-control"
              />
            </div>
            <!-- /.input-group -->

            <help-block field="phone" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3">
            <label class="control-label">Mobile</label>
            <div class="input-group">
              <input
                name="mobile"
                v-model="editContact.mobile"
                type="text"
                class="form-control"
              />
            </div>
            <!-- /.input-group -->

            <help-block field="mobile" />
          </div>
          <!-- /.form-group -->

          <h3>Notification Options</h3>
          <div class="toggle-chips mb-3">
            <button
              @click="
                editContact.sla_notifications = !editContact.sla_notifications
              "
              type="button"
              class="btn"
              :class="[
                editContact.sla_notifications ? 'btn-primary' : 'btn-default',
              ]"
            >
              <i
                v-if="editContact.sla_notifications"
                class="far fa-fw fa-check"
              ></i>
              SLA
            </button>
            <button
              @click="
                editContact.invoice_notifications = !editContact.invoice_notifications
              "
              type="button"
              class="btn"
              :class="[
                editContact.invoice_notifications
                  ? 'btn-primary'
                  : 'btn-default',
              ]"
            >
              <i
                v-if="editContact.invoice_notifications"
                class="far fa-fw fa-check"
              ></i>
              Invoices
            </button>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-rounded btn-default"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <c-button
              @click="handleSaveContact"
              class="btn btn-rounded btn-primary"
              >Save</c-button
            >
          </div>
        </div>
        <!-- /.drawer-body -->
      </div>
      <!-- /.drawer-contents -->
    </div>
    <!-- /.drawer -->
  </div>
</template>

<style>
.form-control {
  box-shadow: none !important;
}

.form-control[readonly] {
  background-color: transparent !important;
}
</style>

<script>
import { mapActions, mapState } from "vuex";
import { http } from "utils";
import { Selectize, LaddaButton } from "components/form/input";
import Datepicker from "vuejs-datepicker";
import $ from "jquery";
import { notify } from "utils";
import { unset, cloneDeep } from "lodash";
import moment from "moment";
import Multiselect from "vue-multiselect";
import { CModal } from "@chameleon/chameleon-vue";

export default {
  $_veeValidate: {
    validator: "new", // give me my own validator scope.
  },
  extends: CModal,
  props: ["title", "contact", "client"],
  components: {
    Selectize,
    LaddaButton,
    Datepicker,
    Multiselect,
  },

  data() {
    return {
      editContact: {},
    };
  },

  watch: {
    contact(value) {
      this.editContact = cloneDeep(value);
    },
  },

  mounted() {
    this.resetContact();

    // CModal resets data when closed, so re-clone the contact each time it opens
    this.addEventListener("open", this.resetContact);
  },

  computed: {
    ...mapState("contacts", ["contacts"]),
    ...mapState("contacts", ["client_id"]),
  },

  methods: {
    ...mapActions("contact", ["addSingle", "updateSingle"]),

    resetContact() {
      this.editContact = cloneDeep(this.contact);

      if (this.client) {
        this.editContact.client = cloneDeep(this.client);
      }
    },

    handleSaveContact() {
      if (this.editContact.id > 0) {
        return this.handleUpdateContact();
      } else {
        return this.handleAddContact();
      }
    },

    async handleAddContact() {
      if (!(await this._validate())) {
        notify.error(
          "Form validation failed, please check your inputs and try again."
        );
        return Promise.reject();
      }

      // Prefer the client passed in, the contacts list client may be from another page
      const clientId = this.client ? this.client.id : this.client_id;

      let payload = Object.assign(this.editContact, { client_id: clientId });

      return this.addSingle(payload)
        .then((response) => {
          //close side drawer
          notify.success("Contact successfully created.");

          this.$emit("created", response.data.id);

          this.$bus.$emit("newContactCreated", response.data.id);
          this.close()
        })
        .catch((error) => {
          if (error.response.status === 422) {
            notify.error(
              "Form validation failed, please check your inputs and try again."
            );
          } else {
            notify.error("Failed to update sla details, please try again.");
          }
        });
    },

    async handleUpdateContact() {
      if (!(await this._validate())) {
        notify.error(
          "Form validation failed, please check your inputs and try again."
        );
        return Promise.reject();
      }

      let payload = {
        id: this.editContact.id,
        payload: this.editContact,
      };

      return this.updateSingle(payload)
        .then((response) => {
          //close side drawer
          notify.success("Contact successfully updated.");

          this.$emit("created", response.data.id);

          this.$bus.$emit("newContactCreated", response.data.id);

          this.close()
        })
        .catch((error) => {
          if (error.response.status === 422) {
            notify.error(
              "Form validation failed, please check your inputs and try again."
            );
          } else {
            notify.error("Failed to update sla details, please try again.");
          }
        });
    },
  },
};
</script>
